module.exports = __webpack_public_path__ + "static/media/shopware_certified_template_designer.ba3ecad4.svg";